
<div>
  <button
    v-if="hasOnlyOneAction"
    @click="tryPerformAction(orderedActions[0])"
    type="button"
    :disabled="isPerformingAction || isInEditMode"
    class="btn action-btn green"
  >
    <template v-if="generatingDocument">
      <xpinner :has-background="false" color="White" speed="fast"/>
    </template>
    {{orderedActions[0].actionName}}
  </button>
  <button
    v-else-if="orderedActions.length > 1"
    :disabled="isPerformingAction || isInEditMode"
    class="dropdown-toggle arrow btn action-btn green"
    id="actionsDropdown"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <template v-if="generatingDocument">
      <xpinner :has-background="false" color="White" speed="fast"/>
    </template>
    Actions
  </button>

  <ul class="dropdown-menu dropdown-menu-right uncover" aria-labelledby="actionsDropdown">
    <li v-for="action in orderedActions" :key="action.action_client_id">
      <button
        :disabled="isPerformingAction || isInEditMode"
        type="button"
        class="dropdown-item"
        @click="tryPerformAction(action)"
      >{{action.actionName}}</button>
    </li>
  </ul>

  <action-confirmation-modal
    v-if="modalStateFor(vueModalID.confirmObjectModelAction).isVisible"
    :state="modalStateFor(vueModalID.confirmObjectModelAction)"
    :index="vueModalID.confirmObjectModelAction"
    @toggle-modal="handleCloseConfirmationModal"
    :overrideConfig="actionConfirmationModalConfig"
    :entry="selectedObjectModelEntry"
    :context="NotesTabContext.Records"
    :note-required="selectedObjectModelAction.require_note"
    :action-title="selectedObjectModelAction.label_title"
  ></action-confirmation-modal>

  <multiple-submissions-modal
    v-if="modalStateFor(vueModalID.multipleSubmissions).isVisible"
    :state="modalStateFor(vueModalID.multipleSubmissions)"
    :index="vueModalID.multipleSubmissions"
    @start-form="startForm"
    @edit-form="editForm"
    @toggle-modal="hideModal(vueModalID.multipleSubmissions)">
  ></multiple-submissions-modal>

  <object-model-action-error-modal
    :state="modalStateFor(vueModalID.objectModelActionError)"
    :index="vueModalID.objectModelActionError"
    @toggle-modal="handleCloseErrorModal"
    :error-title="actionErrorTitle"
    :error-message="actionErrorMessage"
  ></object-model-action-error-modal>

  <object-model-action-custom-notification
    v-if="!isPreview"
    :state="modalStateFor(vueModalID.objectModelActionCustomNotification)"
    :index="vueModalID.objectModelActionCustomNotification"
    :entry="selectedObjectModelEntry"
    @toggle-modal="handleCloseCustomNotificationModal"
    @send="sendCustomNotification(selectedObjectModelEntry, $event)"
  ></object-model-action-custom-notification>

  <process-flow-submission-app
    v-if="modalStateFor(vueModalID.ProcessFlowSubmissionApp).isVisible"
    :state="modalStateFor(vueModalID.ProcessFlowSubmissionApp)"
    :index="vueModalID.ProcessFlowSubmissionApp"
    :process-flow="processFlow"
    :process-flow-submission-id="processFlowSubmissionId"
    @toggle-modal="processFlowExecutionOnCancel"
    @finished="processFlowExecutionOnFinished"
    @failed="processFlowExecutionOnFailed"
  />
</div>
